export const auditColumns = [
  {
    title: "User",
    style: { width: "auto" },
  },
  {
    title: "Operator",
    style: { width: "auto" },
  },
  {
    title: "Action",
    style: { width: "auto" },
  },
  {
    title: "Date",
    style: { width: "auto" },
  },
  {
    title: "Data",
    style: { width: "auto" },
  },
];

export const PAGE_SIZE = 10;
